import { Component, OnInit, ComponentFactoryResolver, ViewContainerRef, Input, Output, EventEmitter, ViewChild, ElementRef, Inject,SimpleChanges } from '@angular/core';
import { ShelfAppendDirective } from '../directives/shelfAppend.directive';
import { ShelfAppendComponent } from '../directives/shelfAppend.component';
import { GoogledriveComponent } from '.././googleDrive/googledrive/googledrive.component';
import { debuglog } from 'util';
import { ShelfPouchDb } from '../shelf.pouchdb.service';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GoogleService } from '../../shared/Google.service';
import {
  Ng4FilesService,
  Ng4FilesConfig,
  Ng4FilesStatus,
  Ng4FilesSelected
} from './ng4-files'

@Component({
  selector: 'app-Clouddata',
  templateUrl: './Clouddata.component.html',
  styleUrls: ['./Clouddata.component.css'],
  animations: [
    trigger('show', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate(300, style({ opacity: 0 }))
      ])
    ]),
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(45deg)' })),
      transition('rotated => default', animate('300ms ease-out')),
      transition('default => rotated', animate('300ms ease-in'))
    ]),
  ],
})
export class ClouddataComponent implements OnInit {
  @Output() cloudEvent = new EventEmitter<any>();
  @Input() selectedLibOptInd: any;
  constructor(private viewContainerRef: ViewContainerRef, public dialog: MatDialog, private componentFactoryResolver: ComponentFactoryResolver, public pouchservice: ShelfPouchDb, ) { }
  appendComponent
  selectedTab = 0 ;

  Selecterlist;
  mydrivedata: string;
  selecterlistname;
  rotateState: string = 'default';
  displayAddNewFileOption = true;
  googleDriveDataobj = [{
    "name": "Google Drive",
    "navigate": "googledrive",
    "icon": "icon-Google-Drive",

  },
  {
    "name": "share with me",
    "navigate": "googledrive",
    "icon": "icon-Google-Drive",

  },
  {
    "name": "Drop Box",
    "navigate": "googledrive",
    "icon": "icon-Drop-Box"
  },
  {
    "name": "One Drive",
    "navigate": "googledrive",
    "icon": "icon-One-Drive"

  }
  ]
  showSubdata = 0
  showSubCon = true;
  toggleIcon

  ngOnInit() {


  }

  ngOnChanges(changes: SimpleChanges) {
    this.selectedLibOptInd = changes.selectedLibOptInd.currentValue;
    if(this.selectedLibOptInd == 2){
      this.openCloseTab('',0);
      this.navigatePage(0,this.enrichmentObj[0]['Blankpage'][0],'drive')
    }
  }

  navigatePage(index, list,state) {
    // this.myContentTab.nativeElement.querySelectorAll('.allItemsCls').classList.remove('selectedListClass');
    this.selecterlistname = list.subData;
    this.Selecterlist = list;
    // this.pouchservice.getBookData(this, list);
    var obj = {
      'name': 'GoogledriveComponent',
      'data': this.Selecterlist,
      'type': this.selecterlistname,
      'myderive': this
    }

    if(state != 'drive'){
      obj.name = 'dropBoxComponent';
      obj.type = list.catname;

    }

    if(list.subData == 'Share with me'){
      this.displayAddNewFileOption = false;
    }else{
      this.displayAddNewFileOption = true;
    }
    this.cloudEvent.emit(obj);
  }
  openCloseTab(evt, ind) {
    if (ind != this.showSubdata && this.showSubCon == true && ind == 0) {
      this.showSubCon = !this.showSubCon;
      this.toggleIcon = !this.toggleIcon;
    }else{
      this.navigatePage(ind,this.enrichmentObj[ind],'dropBox')
    }
  }
  isShowAddNewFolder = false;
  isNewItemsShow = false
  createNewBookOptions() {
    var r = this.mydrivedata;
    this.isNewItemsShow = !this.isNewItemsShow;
    this.rotate()

  }
  rotate() {
    this.rotateState = (this.rotateState == 'default' ? 'rotated' : 'default');
    if (this.isShowAddNewFolder) {
      this.isShowAddNewFolder = false;
    }
  }

  public addNewFolderArr = [{ 'name': 'Create Folder', "value": "CREATE FOLDER", 'icon': 'icon-Create-Folder' }, { 'name': 'Upload file', 'icon': 'icon-EBE', "value": "upload files" }]
  enrichmentObj = [{
    "Blankpage": [{ "subData": "My Drive", "icon": " icon-My-Drive" }, { "subData": "Share with me", "icon": "icon-Shared-with-me" }],
    "catname": "Google Drive",
    "iconName": "GOOGLE",
    "subData": "GoogleDrive"
  },

  {
    "catname": "DropBox",
    "iconName": " icon-Drop-Box"
  },
  {
    "catname": "OneDrive",
    "iconName": "icon-One-Drive"
  }]
  selectcategory(value) {
    //// if(value=='CREATE FOLDER'){
    this.openDialog(value, this.mydrivedata)
    // }
    //  this.mydrivedata.mimetype=value
    //   this.data.popupProps.curComp.selectdata(value);
    //   this.data.popupProps.showPopup=false
    //   this.data.popupProps.curComp.fdata

  }
  newElePopup(value) {
    let dialogRef = this.dialog.open(Uploadfile, {
      width: '200px',
      data: value,

      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        //this.createNewElessonBook(result)
      }
    });
  }

  openDialog(optName, value): void {
    let name = 'New Folder';



    let information = { 'name': name, 'Data': value }
    let widthVal = '315px';


    if (optName == 'upload files') {
      this.newElePopup(value);
      return;
    }

    else {
      let dialogRef = this.dialog.open(NewFolderDialogGoogle, {
        width: widthVal,
        data: information,
        disableClose: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {

        }
      });
    }
  }

}
// selectcolud(name){
//   
//   if(name=="Google Drive"){
//     this.appendComponent = GoogledriveComponent;

//   }

//   let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.appendComponent);
//   let viewContainerRef = this.shelfHost.viewContainerRef;
//   viewContainerRef.clear();

//   let componentRef = viewContainerRef.createComponent(componentFactory);

// }

@Component({
  selector: 'app-popup',
  templateUrl: './NewFolderDialogGoogle.popup.html',
  styleUrls: ['./Clouddata.component.css']
})

export class NewFolderDialogGoogle {

  showError = false;
  newFolderTitle = '';
  selectedThemeInd = undefined;
  bookNameErr = false;
  ebeBookTitle = '';
  selectedBookTypeInd: Number = 0;
  selectedTemplateViewInd = 0;
  bookTemplates;
  bookTemplateDetails;
  bookThemes;
  parentid
  url;
  imageDetails;
  constructor(
    public dialogRef: MatDialogRef<NewFolderDialogGoogle>, private google: GoogleService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(name) {
    this.showError = false;


    if (this.data.Data.fdata.length > 0) {

      var r = this.data.Data.fdata.length - 1
      this.parentid = this.data.Data.fdata[r].id
    }
    this.google.Createdrivefolder(name, this.parentid, this.data.Data)
    this.dialogRef.close();
    // this.data.Data.popupProps.curComp.Getfolderdtaledrive(this.data)
  }
  updateNewFolderName(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

}

@Component({
  selector: 'app-createELE',
  templateUrl: './Uploadfile.popup.html',
  styleUrls: ['./Clouddata.component.css']
})

export class Uploadfile {
  newEleTitle;
  imageDetails;
  parentid
  constructor(
    public dialogRef: MatDialogRef<Uploadfile>,
    @Inject(MAT_DIALOG_DATA) public data: any, private google: GoogleService) {

  }
  selectedImage = undefined;
  @ViewChild('selectImg', { read: ElementRef }) public selectImg: ElementRef;
  onNoClick(): void {
    this.dialogRef.close();
  }
  selectedFiles
  selectedname
  public filesSelect(selectedFiles: Ng4FilesSelected): void {

    if (selectedFiles.status !== Ng4FilesStatus.STATUS_SUCCESS) {
      this.selectedFiles = selectedFiles.status;
      return;
    }

    if (this.data.fdata.length > 0) {

      var r = this.data.fdata.length - 1
      this.parentid = this.data.fdata[r].id
    }
    this.google.insertFileintodrive(selectedFiles.files[0], selectedFiles.files, this.parentid, this.data);
    this.dialogRef.close();

    this.selectedname = Array.from(selectedFiles.files).map(file => file.name);
  }
  onYesClick() {
    let tempObj = {
      name: this.newEleTitle,
      imageUrl: this.url,
      imageDetails: this.imageDetails
    }
    if (this.data.fdata.length > 0) {

      var r = this.data.fdata.length - 1
      this.parentid = this.data.fdata[r].id
    }
    // this.google.insertFileintofloder(tempObj.imageDetails.target.files[0],tempObj.imageDetails.target.files,localStorage.currentDriveMediaId,false,this);
    this.google.insertFileintodrive(tempObj.imageDetails.target.files[0], tempObj.imageDetails.target.files, this.parentid, this.data)
    this.dialogRef.close(tempObj);
  }

  selectImages(ev) {
    this.selectImg.nativeElement.click();
  }
  imageChangedEvent
  url;
  readURL(fileInput) {
    this.imageChangedEvent = fileInput;
    this.imageDetails = fileInput;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = ((e) => {
        this.url = e.target['result'];
      });
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/Clouddata.component.ts